import { render, staticRenderFns } from "./ui-label.vue?vue&type=template&id=a1d51f96&"
import script from "./ui-label.vue?vue&type=script&lang=ts&"
export * from "./ui-label.vue?vue&type=script&lang=ts&"
import style0 from "./ui-label.vue?vue&type=style&index=0&id=a1d51f96&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports